"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BT021_UPDATE_SUBSCRIPTION_BASKET_ERROR = void 0;
var DEFAULT_WORDING = "\n  Vous ne pouvez pas choisir ce jour de retrait car il est actuellement complet.\n  Veuillez s\u00E9lectionner un autre jour et/ou un autre point de retrait.";
exports.BT021_UPDATE_SUBSCRIPTION_BASKET_ERROR = {
    text: DEFAULT_WORDING,
    buttons: [{
            label: 'Changer mon point de retrait',
            route: { name: 'tunnel-delivery-type-step1' },
        }],
};
exports.default = {
    default: {
        text: DEFAULT_WORDING,
    },
    'TemporaryCustomerApi.addBasketSubscription': exports.BT021_UPDATE_SUBSCRIPTION_BASKET_ERROR,
    'UserApi.addSubscriptionToSubscriptionBasket': exports.BT021_UPDATE_SUBSCRIPTION_BASKET_ERROR,
    'UserApi.setSubscriptionProduct': exports.BT021_UPDATE_SUBSCRIPTION_BASKET_ERROR,
};
//# sourceMappingURL=BT021Handler.js.map